export default "__VITE_ASSET__D17N5Mw4__"